import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { C as CheckboxIcon } from '../../Checkbox/CheckboxIcon-DoWTNtSK.js';
import { u as useTileGroupContext } from '../TileGroupContext-CvSfRsxH.js';
import { a as ChildBox, M as Main, I as IconWrapper, T as TileControlTextContainer, b as TileControlText, S as SubText } from './Tile.styles-CkHDNsw_.js';
import { u as useTileContext, b as useTileControlContext } from './TileContext-CI56_oXw.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { T as TileToggleArea } from './TileToggleArea/TileToggleArea-3SYh9iFD.js';

const titleSizeMap = {
  base: 'base',
  large: 'xlarge'
};
const TileControl = ({
  hideStartBorder = false,
  renderIcon,
  subText,
  text,
  title,
  titleFontSize = 'base',
  contentPosition = 'start',
  taktId,
  taktValue
}) => {
  const {
    multiple,
    name,
    disabled: tileGroupDisabled
  } = useTileGroupContext();
  const {
    disabled: tileDisabled,
    selected
  } = useTileContext();
  const {
    focusProps,
    label,
    onChange,
    value,
    innerRef,
    restProps
  } = useTileControlContext();
  const disabled = tileGroupDisabled || tileDisabled;
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: "tile-control"
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(ChildBox, {
    hideStartBorder: hideStartBorder,
    padding: "none",
    $flex: 1
  }, /*#__PURE__*/React__default.createElement(TileToggleArea, _extends({}, restProps, {
    taktId: taktId,
    taktValue: taktValue,
    checked: selected,
    disabled: disabled,
    focusProps: focusProps,
    label: label,
    multiple: multiple,
    name: name,
    onChange: onChange,
    ref: innerRef,
    value: value
  }), /*#__PURE__*/React__default.createElement(Main, _extends({
    $contentPosition: contentPosition,
    $disabled: disabled,
    $checked: selected
  }, getDataTaktAttributes({
    taktIdSuffix: 'content',
    contextOnlyTaktValues: {
      checked: selected,
      disabled,
      value
    }
  })), multiple && /*#__PURE__*/React__default.createElement(CheckboxIcon, {
    size: "base",
    checked: selected,
    disabled: disabled
  }), renderIcon && /*#__PURE__*/React__default.createElement(IconWrapper, null, renderIcon({
    disabled,
    selected
  })), /*#__PURE__*/React__default.createElement(TileControlTextContainer, null, title && /*#__PURE__*/React__default.createElement(TileControlText, {
    size: titleSizeMap[titleFontSize],
    weight: "bold",
    color: "inherit"
  }, title), typeof text === 'string' ? /*#__PURE__*/React__default.createElement(TileControlText, {
    size: "small",
    color: "inherit"
  }, text) : text, subText && /*#__PURE__*/React__default.createElement(SubText, {
    size: "small",
    color: "inherit",
    $disabled: disabled
  }, subText))))));
};

export { TileControl as T };
//# sourceMappingURL=TileControl-BxxyD2al.js.map
